/**
 * The app's canonical public origin.
 *
 * Apex, not www — `www.entredash.com` 301s to the apex in production, so
 * every canonical URL, share link, and syndication attribution should use
 * this form.
 *
 * IMPORTANT: this mirrors `SITE_URL` in `blog/render.mjs`, which is the
 * build-time source used for the static blog's canonical tags, og:url, and
 * sitemap. The blog renderer is a plain `.mjs` module consumed by the Vite
 * plugin at build time and cannot import TypeScript, which is why the value
 * exists in two places. Change both together.
 *
 * These previously both read `https://www.meinvent.com`, a host that no
 * longer resolves — which meant every blog post shipped a canonical tag and
 * an og:url pointing at a dead domain. Do not let that drift back.
 */
export const SITE_ORIGIN = 'https://entredash.com';

/** Public URL of a blog post, given its slug. */
export function blogPostUrl(slug: string): string {
  return `${SITE_ORIGIN}/blog/${slug}`;
}

/** Display form of a blog post URL, no scheme. Used in UI labels. */
export function blogPostDisplayUrl(slug: string): string {
  return `entredash.com/blog/${slug}`;
}
